import React from 'react';
import PropTypes from 'prop-types';

import './CFSForm.css';
import { RemoveButton } from './Buttons';

const SpeakerDetail = ({ fields, speaker, removeSpeaker, updateSpeaker, isValidSpeakerValue }) => (
    <div>
        <div className="is-divider custom-divider" data-content="Speaker detail" />
        {fields.speakers.length > 1 && (
            <RemoveButton id={speaker.id} removeSpeaker={removeSpeaker} />
        )}
        <div className="form-group columns">
            <label
                className={`control column is-2 label ${
                    isValidSpeakerValue(speaker.id, 'speakerName') ? '' : ' has-error'
                }`}
                htmlFor="speakerName"
            >
                {speaker.speakerName.label}
            </label>
            <div className="column fix-space-sm">
                <input
                    className={`form-control input is-rounded ${
                        isValidSpeakerValue(speaker.id, 'speakerName') ? '' : ' is-danger'
                    }`}
                    name="speakerName"
                    onChange={e => updateSpeaker(speaker.id, e)}
                    placeholder={speaker.speakerName.placeholder}
                    type="text"
                    value={speaker.speakerName.value}
                />
            </div>
            <label
                className={`control column is-2 label ${
                    isValidSpeakerValue(speaker.id, 'email') ? '' : ' has-error'
                }`}
                htmlFor="email"
            >
                {speaker.email.label}
            </label>
            <div className="column">
                <input
                    className={`form-control input is-rounded ${
                        isValidSpeakerValue(speaker.id, 'email') ? '' : ' is-danger'
                    }`}
                    name="email"
                    onChange={e => updateSpeaker(speaker.id, e)}
                    placeholder={speaker.email.placeholder}
                    type="email"
                    value={speaker.email.value}
                />
            </div>
        </div>
        <div className="form-group columns">
            <label
                className={`control column is-2 label ${
                    isValidSpeakerValue(speaker.id, 'company') ? '' : ' has-error'
                }`}
                htmlFor="company"
            >
                {speaker.company.label}
            </label>
            <div className="column fix-space-sm">
                <input
                    className={`form-control input is-rounded ${
                        isValidSpeakerValue(speaker.id, 'company') ? '' : ' is-danger'
                    }`}
                    name="company"
                    onChange={e => updateSpeaker(speaker.id, e)}
                    placeholder={speaker.company.placeholder}
                    type="text"
                    value={speaker.company.value}
                />
            </div>
            <label
                className={`control column is-2 label ${
                    isValidSpeakerValue(speaker.id, 'country') ? '' : ' has-error'
                }`}
                htmlFor="country"
            >
                {speaker.country.label}
            </label>
            <div className="column">
                <input
                    className={`form-control input is-rounded ${
                        isValidSpeakerValue(speaker.id, 'country') ? '' : ' is-danger'
                    }`}
                    name="country"
                    onChange={e => updateSpeaker(speaker.id, e)}
                    placeholder={speaker.country.placeholder}
                    type="text"
                    value={speaker.country.value}
                />
            </div>
        </div>
        <div className="form-group columns ">
            <label
                className={`control column is-2 label ${
                    isValidSpeakerValue(speaker.id, 'speakerBio') ? '' : ' has-error'
                }`}
                htmlFor="speakerBio"
            >
                {speaker.speakerBio.label}
            </label>
            <div className="column">
                <textarea
                    className={`form-control textarea ${
                        isValidSpeakerValue(speaker.id, 'speakerBio') ? '' : ' is-danger'
                    }`}
                    name="speakerBio"
                    onChange={e => updateSpeaker(speaker.id, e)}
                    placeholder={speaker.speakerBio.placeholder}
                    rows="2"
                    type="text"
                    value={speaker.speakerBio.value}
                />
            </div>
        </div>
        <div className="form-group columns ">
            <label
                className={`control column is-2 label ${
                    isValidSpeakerValue(speaker.id, 'photoLink') ? '' : ' has-error'
                }`}
                htmlFor="photoLink"
            >
                {speaker.photoLink.label}
            </label>
            <div className="column">
                <input
                    className={`form-control input is-rounded ${
                        isValidSpeakerValue(speaker.id, 'photoLink') ? '' : ' is-danger'
                    }`}
                    name="photoLink"
                    onChange={e => updateSpeaker(speaker.id, e)}
                    placeholder={speaker.photoLink.placeholder}
                    type="text"
                    value={speaker.photoLink.value}
                />
            </div>
        </div>
    </div>
);

SpeakerDetail.propTypes = {
    // eslint-disable-next-line
    fields: PropTypes.object.isRequired,
    isValidSpeakerValue: PropTypes.func.isRequired,
    removeSpeaker: PropTypes.func.isRequired,
    // eslint-disable-next-line
    speaker: PropTypes.object.isRequired,
    updateSpeaker: PropTypes.func.isRequired
};

export default SpeakerDetail;
